// This is the implementation of the global flag enableCanvasMathRectChecks,
// which looks for nodes that are drawn outside the top node's rectangle. All
// calls to this should be guarded by a check of that flag.

const _ = require("lodash");
const Math2D = require("../util/Math2D");

let nodeRects;

const getRect = function(x, y, node, measure) {
	if (measure.height) {
		return [x, y, measure.width, measure.height];
	} else {
		return [x, y - measure.top, measure.width, measure.top + measure.bottom];
	}
};

// Call before starting to draw CanvasMath nodes.
const begin = function() {
	nodeRects = [];
};

// Call for each drawn node.
const addNode = function(rc, x, y, node, measure) {
	nodeRects.push({
		node,
		rect: rc.transformRect(getRect(x, y, node, measure)),
	});
};

// Call at end of CanvasMath drawing. Either logs errors to rc or does nothing.
const end = function(rc, x, y, topNode, topMeasure) {
	// This padding is just to avoid a floating point inconsistency from
	// triggering a false positive. Banvas can be picky down to the pixel level,
	// so we do not want nontrivial padding here.
	const topRect = Math2D.padRect(
		rc.transformRect(getRect(x, y, topNode, topMeasure)),
		0.0001
	);
	nodeRects.forEach(({node, rect}) => {
		if (!Math2D.isRectInside(rect, topRect)) {
			const rectStr = JSON.stringify(rect.map(a => _.round(a, 2)));
			const topRectStr = JSON.stringify(topRect.map(a => _.round(a, 2)));
			rc.pushError(
				"node of type " +
					node.type +
					" measured outside of containing rectangle. " +
					"node: " +
					rectStr +
					", top: " +
					topRectStr
			);
		}
	});
	nodeRects = null;
};

module.exports = {
	begin,
	addNode,
	end,
};
